import { Constants } from "@core/Utils/Constants";
import { MenuSettings } from "./MenuSettings";
import { quality, SetQuality } from '@core/Utils/HelperFunction';
import { Language, Messages } from '@core/GUI/Language';
import Phaser from "phaser";

export class MenuQualitySettings extends MenuSettings {

    private qualityText: Phaser.GameObjects.Text;
    private qualitySlider: Phaser.GameObjects.Image;

    constructor(scene, text: string, spriteSheet: string, icon: string, buttonHeightMultiplier: number, sliderImage: string) {
        super(scene, text, spriteSheet, icon, buttonHeightMultiplier);

        this.qualityText = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.SETTINGS_RENDER), Constants.MENU_BUTTON_STYLE_FONT);
        this.qualityText.setOrigin(0, 0.5);
        this.add(this.qualityText);

        this.qualitySlider = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, sliderImage);
        this.qualitySlider.setOrigin(0.5);
        this.qualitySlider.slider = this.scene.plugins.get('sliderplugin').add(this.qualitySlider, {
            endPoints: [{
                x: this.qualitySlider.x - 200,
                y: this.qualitySlider.y
            },
            {
                x: this.qualitySlider.x + 200,
                y: this.qualitySlider.y
            }
            ],
            value: quality
        });
        this.qualitySlider.slider.on('valuechange', function (newValue, prevValue) {
            SetQuality(0.5 + 0.5 * newValue); //60%-100%
            if (newValue >= 1.0 || newValue <= 0.0)
                window.dispatchEvent(new Event('resize'));
        });
        this.add(this.qualitySlider);

        this.background
            .lineStyle(3, 0xffffff, 1)
            .strokePoints(this.qualitySlider.slider.endPoints);

    }

    override handleUp(m, x, y, e): void {
        window.dispatchEvent(new Event('resize'));
        e.stopPropagation();
    }

    override ResizeAndMove(x: number, y: number, width: number, singleButtonHeight: number, padding: number) {
        super.ResizeAndMove(x, y, width, singleButtonHeight, padding);

        this.qualityText.setFontSize(singleButtonHeight / 2.9);
        this.qualityText.setPosition(padding, singleButtonHeight - padding);

        let sliderStartPos = this.qualityText.displayWidth + this.qualitySlider.displayWidth / 2 + padding * 4;
        let sliderEndPos = this.width - this.qualitySlider.displayWidth / 2 - padding * 2;

        this.qualitySlider.setDisplaySize(singleButtonHeight / 2, singleButtonHeight / 2);
        this.qualitySlider.setPosition(sliderStartPos + (sliderEndPos - sliderStartPos) * this.qualitySlider.slider.value, this.qualityText.y);
        this.qualitySlider.slider.endPoints = [{
            x: sliderStartPos,
            y: this.qualitySlider.y
        },
        {
            x: sliderEndPos,
            y: this.qualitySlider.y
        }
        ];

        this.background
            .lineStyle(3, 0xffffff, 1)
            .strokePoints(this.qualitySlider.slider.endPoints);
    }
}